import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './Components/Home/Home';
import ChargesPage from './Components/Charges/Charges';
import RequestCharge from './Components/RequestCharge/RequestCharge';
import CommentsPage from "./Components/Model/Comments"
import Preview from './Components/Preview/Preview';
import BulkInvoiceUpload from './Components/BulkUpload/bulkupload';
import BulkReassignPage from './Components/BulkUpload/BulkReassignPage';
import Callback from "./callback";
import ProtectedRoute from './ProtectedRoute';
import { UserProvider } from './contexts/UserContext';
import Approvermatrix from './Components/Approver/Approvermatrix';
import Analytics from './Components/Analytics/Analytics';
import AccessRequestQueue from './Components/AccessRequestQueue/AccessRequestQueue';

const ACCESS_REQUEST_ADMIN_EMAILS = (process.env.REACT_APP_PO_ADMIN_EMAILS || "")
  .split(",")
  .map(e => e.trim().toLowerCase())
  .filter(Boolean);

function App() {
  return (
    <UserProvider>
      <Routes>
        <Route path="/oauth2/callback" element={<Callback />} />
        <Route path="/"  element={
            <ProtectedRoute allowedRoles={['IDAMaerskCX', 'MaerskInternal','IDAVestasApprover','IDAVestasViewer','IDAMaerskBilling','IDAMaerskViewer']}>
              <Home />
            </ProtectedRoute>
          } />
        <Route path="/notice/:id" element={
            <ProtectedRoute allowedRoles={['IDAMaerskCX', 'MaerskInternal','IDAVestasApprover','IDAVestasViewer','IDAMaerskBilling','IDAMaerskViewer']}>
              <ChargesPage />
            </ProtectedRoute>
          } />
        {/* Protect the RequestCharge route */}
        <Route
          path="/requestCharge"
          element={
            <ProtectedRoute allowedRoles={['IDAMaerskCX', 'MaerskInternal']}>
              <RequestCharge />
            </ProtectedRoute>
          }
        />
        <Route path="/comments/:id" element={
            <ProtectedRoute allowedRoles={['IDAMaerskCX', 'MaerskInternal','IDAVestasApprover','IDAVestasViewer','IDAMaerskBilling','IDAMaerskViewer']}>
              <CommentsPage />
            </ProtectedRoute>
          } />
        <Route
          path="/preview/:sessionId"
          element={
            <ProtectedRoute allowedRoles={['IDAMaerskCX','MaerskInternal']}>
              <Preview />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bulk-invoice-upload"
          element={
            <ProtectedRoute allowedRoles={['IDAMaerskCX', 'IDAVestasApprover','IDAMaerskBilling']}>
              <BulkInvoiceUpload />
            </ProtectedRoute>
          }

        />
        <Route
          path="/bulk-reassign"
          element={
            <ProtectedRoute allowedRoles={['IDAVestasApprover','IDAMaerskBilling']}>
              <BulkReassignPage />
            </ProtectedRoute>
          }

        />
        <Route
          path="/approver-matrix"
          element={
            <ProtectedRoute allowedRoles={['IDAMaerskCX', 'MaerskInternal','IDAVestasApprover','IDAVestasViewer','IDAMaerskBilling','IDAMaerskViewer']}>
              <Approvermatrix />
            </ProtectedRoute>
          }
        />
        <Route
          path="/analytics"
          element={
            <ProtectedRoute allowedRoles={['IDAMaerskCX', 'IDAVestasViewer', 'IDAMaerskViewer', 'IDAMaerskBilling','IDAVestasApprover']}>
              <Analytics />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/access-requests"
          element={
            <ProtectedRoute
              allowedRoles={['IDAMaerskCX', 'MaerskInternal', 'IDAVestasApprover', 'IDAVestasViewer', 'IDAMaerskBilling', 'IDAMaerskViewer']}
              allowedEmails={ACCESS_REQUEST_ADMIN_EMAILS}
            >
              <AccessRequestQueue />
            </ProtectedRoute>
          }
        />
      </Routes>
    </UserProvider>
  );
}

export default App;
